





















































import OrderContentTop from '@/components/common/order/OrderContentTop.vue';
import PageTitle from '@/components/common/PageTitle.vue';
import OrderHoldDeliveryGrids from '@/components/order/mixins/OrderHoldDeliveryGrids';
import ItemTable from '@/components/common/order/ItemTable.vue';
import {Component, Mixins, Ref} from 'vue-property-decorator';
import {State} from 'vuex-class';
import {Mall} from 'supporter';
import { i18nObjectByKey} from '@/utils/i18n';
import {ncpPopup} from '@/utils/commonUtils';
import {getToday, addDay} from '@/utils/dateUtils';
import {CustomGroupFlagCallbackInfo} from '@/components/common/order/mixins/OrderGridsColums';
import OrderGridBrokenFreeGiftMixin from '@/views/order/mixins/OrderGridBrokenFreeGiftMixin.vue';

@Component({
  components: {OrderContentTop, PageTitle, ItemTable}
})
export default class OrderHoldDelivery extends Mixins(OrderHoldDeliveryGrids, OrderGridBrokenFreeGiftMixin) {
	@Ref('gridBottom')
	private readonly gridRef: ItemTable;

  @State('malls', {namespace: 'mall'})
  private mallsArr!: Mall[];
  private orderListContent: any = [];
  private theExcelDownIfo: any = {
    fileName: '',
    columns: {},
    formatters: {}
  };
  private normalCount: number = 0;
  private delayedCount: number = 0;
  private totalCount: any = 0;
  private initPageSize: number = 30;
  private pageSize = this.initPageSize;
  private request: any = {
    params: {}
  };
  private memberGroup: any[] = [];
  private showMemberGroup: boolean = false;
  private exchangeHelpData: any = {
    id: 'memberGroup',
    width: 400,
    maxHeight: 300,
    title: 'ORDER_LIST_GRIDS_MEMBER_GROUP_LAYER_TITLE',
    nonFooter: true
  };
  private searchDateTypeArr: any[] = [
    {
      value: 'STATE_CHANGE_YMDT',
      name: '배송보류 처리 일시'
    },
    {
      value: 'ORDER_YMDT',
      name: '주문일시'
    }
  ];
  private tableOptions = {
    onLoadSearch: false,
    haveConfigBtn: true,
    haveExcelDownBtn: true,
    gridName: 'PROMOTION_COUPON_GRID',
    excelDownInfo: {
      fileName: '',
      columns: {},
      formatters: {},
      nameDateFormat: 'YYYYMMDD_HHmmss'
    }
  };
  private isRouteHaveQuery: boolean = true;
  private created(): void {
    this.exchangeHelpData = i18nObjectByKey(this, this.exchangeHelpData, 'title');
  }
  private mounted(): void {
    $('body').on('click', '.ordererPopup', $.proxy(this.orderNameClick, this));
    $('body').on('click', '.member-group-name-grid', $.proxy(this.clickMemberGroupNameInGrid, this));
    this.getDeliveryHoldSummary();
    this.search(1, this.initPageSize);
  }
  private destroyed(): void {
    $('body').off('click', '.ordererPopup', $.proxy(this.orderNameClick, this));
    $('body').off('click', '.member-group-name-grid', $.proxy(this.clickMemberGroupNameInGrid, this));
  }
  private orderNameClick(e: any): void {
    const memberno = $(e.target).data('memberno');
    ncpPopup(`/member/popup/crm/${memberno}`, 'ORDER_LIST_GRIDS_ORDER_NAME_POPUP_TITLE', 1100, 980);
  }
  private clickMemberGroupNameInGrid(e: any): void {
    this.memberGroup = [];
    this.memberGroup = JSON.parse($(e.target).data('json').replace(/\\\"/g, '"'));
    this.showMemberGroup = true;
  }
  private handleInitRequest(e: any): void {
    this.request = {
      params: {}
    };
    this.$set(this.request, 'params', e);

    if (this.$route.query.holdDelivery1Month) {
      this.$api.getOrderOptionsOrderGridInfo().then(({data: {holdDeliveryRecently}})=>{
        this.request.params.startYmd = holdDeliveryRecently.startYmd;
        this.request.params.endYmd = holdDeliveryRecently.endYmd;
        this.search(1, this.initPageSize);
      })

    }

    if (this.$route.query.holdDelivery3MonthsDelay) {
      this.$api.getOrderOptionsOrderGridInfo().then(({data: {holdDeliveryDelay}})=>{
        this.request.params.startYmd = holdDeliveryDelay.startYmd;
        this.request.params.endYmd = holdDeliveryDelay.endYmd;
        this.request.params.delay = true;
        this.search(1, this.initPageSize);
      })
    }

    this.isRouteHaveQuery = false;
  }

  private initExcelColums(): void {
    let columns: any = this.gridProps.columns.map((item: any) => {
      if(item.visible === true) {
        return item.name;
      }
    });
    this.tableOptions.excelDownInfo.columns = [];
    columns.forEach((el: any): any => {
      this.tableOptions.excelDownInfo.columns[el] = this.excelDownInfo.columns[el];
    });
    this.tableOptions.excelDownInfo.formatters = this.excelDownInfo.formatters;
    this.tableOptions.excelDownInfo.fileName = 'order_';
  }
  private getDeliveryHoldSummary() {
    const mallNos: number[] = [];
    this.mallsArr.map((item) => {
      const mallNo = item.mallNo;
      if (Number(mallNo) !== 0) {
        mallNos.push(Number(mallNo));
      }
    });
    let obj: any = {
      params: {
        mallNos: mallNos.join(',')
      }
    };
    this.$api.getOrderOptionsDeliveryHoldSummary(obj).then((res: any) => {
      this.delayedCount = res.data.delayedCount;
      this.normalCount = res.data.normalCount;
    });
  }
  private releaseHoldDelivery() {
    let checkedRowList = (this.$refs.gridBottom as any).getCheckedRows();
    if (checkedRowList.length === 0) {
      alert(this.$t('ORDER_ORDER_CONTENT_TOP_CHECKLIST_EMPTY'));
      return;
    }

    if(checkedRowList.some(checkedRow => checkedRow.payType === 'NAVER_PAY')){
      alert(this.$t('ORDER_ORDER_CONTENT_TOP_NAVER_PAY_HOLD_ALERT'));
      return
    }

    let obj = {
      params: {
        orderOptionNos: checkedRowList.map((row: any) => row.orderProductOptionNo).join(',')
      }
    };
    this.$api.putOrderOptionsReleaseHoldDelivery(obj).then(() => {
      alert(this.$t('ORDER_ORDER_CONTENT_TOP_PUT_SUCCESS'));
      this.search(1, this.initPageSize);
    });
  }
  private handleSearch(e: any, page: number = 1, size: number): void {
    this.request = {
      params: {}
    };
    this.$set(this.request, 'params', e);
    this.search(page, size);
  }

  private handleCancel(): void {
    this.request.params.startYmd = addDay(new Date(), -7);
    this.request.params.endYmd = getToday();
    this.search(1, this.initPageSize);
  }
  private displayTitle() {
    if ($('#holdDelivery1Month').val() == 'true') {
      $('.count_title').html('배송보류 처리');
      $('.filterLi').removeClass('on');
      $('.holdDelivery1Month').addClass('on');
    } else if ($('#holdDelivery3MonthsDelay').val() == 'true') {
      $('.count_title').html('배송보류 지연');
      $('.filterLi').removeClass('on');
      $('.holdDelivery3MonthsDelay').addClass('on');
    } else {
      $('.count_title').html('조회결과');
      $('.filterLi').removeClass('on');
    }
  }

  private search(page: number = 1, size: number): void {
    this.displayTitle();

    this.pageSize = size || this.gridProps.options.pageOptions.perPage || this.initPageSize;

    // this.request.params.orderStatusTypes = ['PRODUCT_PREPARE', 'DELIVERY_PREPARE'];
    this.request.params.holdDelivery = true;
    this.request.params.holdByReservation = false;
    this.request.params.includeHoldDelivery = true;
    this.request.params.includeReservation = false;
    this.request.params.page = page;
    this.request.params.size = this.pageSize;
    this.request.params.claimType = 'NONE';

    $('#loading').show();
    this.$api
      .getOrderOptionsOrderGrid(this.request)
      .then((res: any) => {
        this.orderListContent = [];
        let content: any = res.data.contents;
        if (res.data.contents.length > 0) {
          this.orderListContent = [...this.formatterList(
            content,
            'orderDeliveryGridDatas',
            'orderProductGridDatas',
            'orderProductOptionGridDatas')
          ];
          let bigRow = [
            'orderNo',
            'platformType',
            'mallNo',
            'orderRegisterType',
            'reservation',
            'memberGroupInfoJson',
            'payType',
            'ordererName',
            'ordererContact1',
            'memberNo',
            'receiverName',
            'receiverContact1',
            'receiverZipCd',
            'address',
            'deliveryAmtInAdvanceYn',
            'deliveryConditionType',
            'customsIdNumber',
            'deliveryCompanyType',
            'invoiceNo',
            'reservationYn',
            'deliveryMemo',
            'lastMainPayAmt'
          ];
          let midRow: any = ['shippingNo', 'deliveryType', 'shippingAreaType', 'lastSubPayAmt'];
          let smallRow: any[] = ['partnerNo', 'hsCode', 'mallProductNo', 'productManagementCd', 'productName', 'productNameEn', 'failInfo'];

          const customGroupFlagCallbackInfo: CustomGroupFlagCallbackInfo = {
            small: (item, originFlag) => item.isFreeGift && originFlag === 'mallProductNo' ? 'orderProductOptionNo': originFlag
          }
          this.orderListContent = [...this.meargeRow(this.orderListContent, bigRow, midRow, smallRow, 'orderNo', 'shippingNo', 'mallProductNo', customGroupFlagCallbackInfo)];
        }
        this.setCommunicateFailBgColor(this.orderListContent,this.$refs.gridBottom);
        this.totalCount = res.data.totalCount;
        this.gridProps.options.pageOptions.page = page;
        this.gridProps.options.pageOptions.perPage = this.pageSize;
        this.gridProps.options.pageOptions.totalCount = res.data.totalCount;
      })
      .finally(() => {
        $('#loading').hide();
      });
  }
}
